interface ISearchForm {
  input: HTMLInputElement;
  form: HTMLDivElement;
}

function getHid(el: HTMLInputElement): string {
  if (el.classList.contains("getHid")) {
    return el.dataset["hid"] ?? "";
  }
  return "";
}

const searchForProducts = (searchForm: ISearchForm) => {
  const hid: string = getHid(searchForm.input); //get hid, if exists (For landing pages created via templates);
  const keyword = searchForm.input.value; //get keyword

  if (hid) {
    location.href = `/SearchResult.aspx?hid=${hid}&q=${keyword}`;
  } else {
    location.href = `/SearchResult.aspx?q=${keyword}`;
  }
};

const setupEventHandlers = (searchForm: ISearchForm) => {
  if (!searchForm) return;

  if (searchForm?.input) {
    searchForm.input.addEventListener("focus", () => {
      searchForm.input.value = "";
    });

    searchForm.input.addEventListener("keydown", (ev) => {
      if (ev.key === "Enter") {
        ev.preventDefault();
        searchForProducts(searchForm);
      }
    });
  }

  if (searchForm?.form) {
    const submitButtons = searchForm.form.getElementsByClassName("submit");

    for (let i = 0; i < submitButtons.length; i++) {
      submitButtons[i].addEventListener("click", () => {
        searchForProducts(searchForm);
      });
    }
  }
};

const getActiveSearchForm: () => ISearchForm | null = () => {
  const searchForm = document.getElementsByClassName(
      "search-form"
    ) as HTMLCollectionOf<HTMLDivElement>,
    customSearchInput = document.getElementById(
      "h-search-custom"
    ) as HTMLInputElement;

  if (customSearchInput) {
    return {
      input: customSearchInput,
      form: searchForm[0],
    };
  }

  const defaultSearchInput = document.getElementById(
    "h-search"
  ) as HTMLInputElement;

  if (defaultSearchInput) {
    return {
      input: defaultSearchInput,
      form: searchForm[0],
    };
  }

  return null;
};

export function setupProductSearch($: JQueryStatic) {
  const searchForm = getActiveSearchForm();

  const searchLink = document.getElementById("search") as HTMLElement,
    searchLinkMenu = document.getElementById("searchlink-menu") as HTMLElement;

  if (searchLink) {
    searchLink.addEventListener("click", () => {
      if (!searchForm) return;

      // triggered by the search icon in the mobile header.
      // On click, prepend the search-form to topblock i.e before logo
      // and show the search bar that already exists

      $(".top-block").prepend(searchForm.form);
      searchForm.form.style.display = "flex";
      searchForm.form.style.flexDirection = "column";
      searchForm.input.focus();
    });

    //hide the search link if there is no search form.
    if (!searchForm) {
      searchLink.style.display = "none";
      searchLinkMenu.style.display = "none";
    }
  }

  // attach event handler to close search button
  $(".close-search").click(() => {
    if (searchForm?.form) {
      searchForm.form.style.display = "none";
    }
  });

  if (searchForm) {
    setupEventHandlers(searchForm);
  }
}
